import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';

const getApiService = () => `${apiUtils.getBaseUri()}/users`;
const getCurrentUserApi = () => `${getApiService()}/current`;

const loadAddresses = async (deliveryCountry, restrictAddress) => {
    const searchParams = new URLSearchParams();
    if (deliveryCountry) {
        searchParams.append('country', deliveryCountry);
        if (restrictAddress) {
            searchParams.append('restrictAddress', restrictAddress);
        }
    }
    const uri = `${getCurrentUserApi()}/addresses?${searchParams.toString()}`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load addresses (${response.status})`);
    }

    return await response.json();
};

const loadBillingAddresses = async () => {
    const uri = `${getCurrentUserApi()}/addresses/billing`;
    const response = await HTTPClient().get(uri);

    if (!response.ok) {
        throw new Error(`Unable to load addresses (${response.status})`);
    }

    return await response.json();
};

const removeAddress = async id => {
    const uri = `${getCurrentUserApi()}/addresses/${id}`;
    const response = await HTTPClient().delete(uri);
    return await response;
};

const setAsDefault = async id => {
    const uri = `${getCurrentUserApi()}/addresses/${id}`;
    const response = await HTTPClient().patchJson(uri, {
        defaultAddress: true,
    });

    if (!response.ok) {
        throw new Error(`Unable to set address as default (${response.status})`);
    }

    return await response;
};

export default {
    loadAddresses,
    loadBillingAddresses,
    setAsDefault,
    removeAddress,
};
